import { getAttrValue } from '@grandvisionhq/utils';
import { getLocalizedString } from './get-localized-string.js';

const getLineItemName = (product, intl)=>{
    if (product.productType === 'sunglasses') {
        return String(getAttrValue(product.masterData.current.variant, 'brand'));
    }
    return getLocalizedString(intl.locale, product.masterData.current.name);
};

export { getLineItemName };
//# sourceMappingURL=get-line-item-name.js.map
